import { SeoLandingTemplate } from "@/components/seo/seo-landing-template";
import {
	AI_TEAMMATES_MARKETING_GOOGLE_ADS_EXTERNAL_LINKS,
	AI_TEAMMATES_MARKETING_GOOGLE_ADS_FAQ_ITEMS,
	AI_TEAMMATES_MARKETING_GOOGLE_ADS_H1,
	AI_TEAMMATES_MARKETING_GOOGLE_ADS_INTERNAL_LINKS,
	AI_TEAMMATES_MARKETING_GOOGLE_ADS_INTRO_PARAGRAPHS,
	AI_TEAMMATES_MARKETING_GOOGLE_ADS_OUTLINE,
	AI_TEAMMATES_MARKETING_GOOGLE_ADS_SECTIONS,
} from "@/constants/seo/ai-teammates-marketing-google-ads-content";
import { AI_TEAMMATES_MARKETING_GOOGLE_ADS_LANDING_UI } from "@/constants/seo/seo-landing-ui";

export function AiTeammatesMarketingGoogleAdsPage() {
	return (
		<SeoLandingTemplate
			ui={AI_TEAMMATES_MARKETING_GOOGLE_ADS_LANDING_UI}
			h1={AI_TEAMMATES_MARKETING_GOOGLE_ADS_H1}
			introParagraphs={AI_TEAMMATES_MARKETING_GOOGLE_ADS_INTRO_PARAGRAPHS}
			outline={AI_TEAMMATES_MARKETING_GOOGLE_ADS_OUTLINE}
			sections={AI_TEAMMATES_MARKETING_GOOGLE_ADS_SECTIONS}
			internalLinks={AI_TEAMMATES_MARKETING_GOOGLE_ADS_INTERNAL_LINKS}
			externalLinks={AI_TEAMMATES_MARKETING_GOOGLE_ADS_EXTERNAL_LINKS}
			faqItems={AI_TEAMMATES_MARKETING_GOOGLE_ADS_FAQ_ITEMS}
		/>
	);
}
